export default {
      id: "icon-billing-usage",
      viewBox: "0 0 16 16",
      url: "/" + "assets/sprite.svg#icon-billing",
      toString: function () {
        return this.url;
      }
    }